import { Link } from 'react-router-dom';
import { profileData } from '@/mocks/articles';

export default function ProfilePreview() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 items-center">
          <div className="w-full lg:w-80 flex-shrink-0">
            <div className="w-full aspect-[3/4] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Japanese%20female%20celebrity%20elegant%20portrait%20in%20simple%20white%20blouse%2C%20natural%20makeup%2C%20soft%20studio%20lighting%20on%20neutral%20background%2C%20professional%20headshot%20style%2C%20warm%20and%20approachable%20expression%2C%20clean%20minimalist%20composition&width=800&height=1067&seq=yutamaki-profile-01&orientation=portrait"
                alt="友田真希 个人资料"
                title="友田真希 个人资料"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="flex-1">
            <p className="text-primary-500 text-xs tracking-[0.2em] uppercase mb-2 font-label">About</p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
              友田真希
              <span className="text-base font-normal text-foreground-500 ml-2">Yūta Maki</span>
            </h2>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
              {[
                { label: '出生日期', value: profileData.birthdate },
                { label: '出生地', value: profileData.birthplace },
                { label: '身高', value: profileData.height },
                { label: '出道年份', value: profileData.debut },
              ].map((item) => (
                <div key={item.label} className="bg-background-50 rounded-lg p-3 border border-background-200/70">
                  <p className="text-xs text-foreground-500 mb-0.5">{item.label}</p>
                  <p className="text-sm font-medium text-foreground-950">{item.value}</p>
                </div>
              ))}
            </div>

            <p className="text-sm text-foreground-600 leading-relaxed line-clamp-4 mb-6">
              {profileData.biography.split('\n\n')[0]}
            </p>

            <div className="flex items-center gap-3">
              <Link
                to="/about"
                className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap"
              >
                完整资料
              </Link>
              <Link
                to="/category/works"
                className="px-6 py-2.5 border border-background-300 text-foreground-700 hover:text-foreground-950 hover:border-foreground-300 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap"
              >
                浏览作品
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}